import { render, staticRenderFns } from "./printSystem.vue?vue&type=template&id=10c42881&scoped=true&"
import script from "./printSystem.vue?vue&type=script&defer=true&lang=js&"
export * from "./printSystem.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./printSystem.vue?vue&type=style&index=0&id=10c42881&prod&lang=less&scoped=true&"
import style1 from "./printSystem.vue?vue&type=style&index=1&id=10c42881&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c42881",
  null
  
)

export default component.exports